'use client';

import { createContext, useCallback, useContext, useRef } from 'react';

import GoogleCalendarModal, { GoogleCalendarModalHandle } from '@/components/bases/GoogleCalendarModal';

interface GoogleCalendarContextType {
  showModal: () => void;
}

const GoogleCalendarContext = createContext<GoogleCalendarContextType | null>(null);

export const useGoogleCalendar = () => {
  const context = useContext(GoogleCalendarContext);
  if (!context) {
    throw new Error('useGoogleCalendar must be used within GoogleCalendarProvider');
  }
  return context;
};

export const GoogleCalendarProvider = ({ children }: { children: React.ReactNode }) => {
  const modalRef = useRef<GoogleCalendarModalHandle>(null);

  const showModal = useCallback(() => {
    modalRef.current?.show({
      name: '',
      email: '',
      companyName: '',
      country: '',
      numberOfEmployees: '',
    });
  }, []);

  return (
    <GoogleCalendarContext.Provider value={{ showModal }}>
      {children}
      <GoogleCalendarModal ref={modalRef} />
    </GoogleCalendarContext.Provider>
  );
};
